import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import GitStacks from './GitStacks';

const Gitelem = () => {
  return (
    <>
    <Col md={4} className="project-card">
    <GitStacks
     imgPath={"https://i.postimg.cc/Wb4F9gsR/Untitled2.png"}
     
    />
  </Col> 
  <Col md={4} className="project-card">
    <GitStacks
     imgPath={"https://i.postimg.cc/2ykw9ySH/Untitled56.png"}
     
    />
  </Col> 


  </> )
}

export default Gitelem